import React, { Component } from "react";

import {
  CButton,
  CCard,
  CCardBody,
  CCardFooter,
  CCardHeader,
  CInputGroup,
  CListGroup,
  CListGroupItem,
  CSwitch,
  CLink
} from "@coreui/react";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { bindActionCreators } from "redux";

// import socketIOClient from "socket.io-client";
import { logout } from "../../../../actions/baseActions";
import { setObj, showHelpdesk } from "../../../../actions/noteActions";
import Breadcrumb from "../../../../components/Breadcrumb";
import HelpdeskCategoryModal from "../../../../components/HelpdeskCategoryModal";
import Interface from "../../../../components/Interface";
import Loading from "../../../../components/Loading";
import ProtectedRoute from "../../../../components/ProtectedRoute";
import QuestionViewerModal from "../../../../components/QuestionViewerModal";
import { Input, Text } from "../../../../components/SlateComponents";
import URL from "../../../../config/api";
import axios from "../../../../config/axios";

import "./style.css";

class Helpdesk extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // categories: [],
      helpdesks: [],
      loading: true,
      loadingSelected: true,
      messagesSelected: null,
      selected: null,
      inputText: [{ type: "paragraph", children: [{ text: "" }] }],
      // creating: false,
      createCategory: null,
      pageId: null,
      objId: null,
      listId: null,
      questionId: null,
      questionModal: null,
      interfaceModal: null,
      categoryModal: false,
      show: false,
      allowMessage: true,
      clearCursor: false
      // empyt: false
    };

    this.overflowDiv = React.createRef();
  }

  componentDidMount() {
    this.props.setObj(16, this.props.currentRoute, this.props.currentRoute);
    this.setState({ loading: true, loadingSelected: true });

    const obj = {
      user_id: this.props.user.user.id,
      mine: true,
      newer: true
    };

    axios
      .post(`${URL.api}helpdesk/helpdesk/list`, obj, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(resp => {
        this.setState({
          helpdesks: resp.data.data,
          loading: false
        });
        if (resp.data.data.length > 0) {
          this.select(resp.data.data[0].id, true, false);
        }
      })
      .catch(error => {
        this.setState({ loadingSelected: false, loading: false });
        this.error("Não foi possível buscar as solicitações");
      });
  }

  friendlyDate(date) {
    const dt = new Date(date);
    const hj = new Date();
    const months = [
      "Janeiro",
      "Fevereiro",
      "Março",
      "Abril",
      "Maio",
      "Junho",
      "Julho",
      "Agosto",
      "Setembro",
      "Outubro",
      "Novembro",
      "Dezembro"
    ];

    if (dt.getFullYear() !== hj.getFullYear()) {
      return `${dt.getDate()} de ${
        months[dt.getMonth()]
      } de ${dt.getFullYear()}`;
    }

    return `${dt.getDate()} de ${
      months[dt.getMonth()]
    }, às ${`00${dt.getHours()}`.slice(-2)}:${`00${dt.getMinutes()}`.slice(
      -2
    )}`;
  }

  error(response) {
    if (response === "Unauthorized") {
      this.props.logout(this.props.user.token);
    } else {
      toastr.error("Falha", response);
    }
  }

  handleClearCursor() {
    // eslint-disable-next-line react/no-access-state-in-setstate
    this.setState({ clearCursor: !this.state.clearCursor });
  }

  reloadHelpdesks() {
    const obj = {
      user_id: this.props.user.user.id,
      mine: true,
      newer: true
    };

    axios
      .post(`${URL.api}helpdesk/helpdesk/list`, obj, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(resp => {
        this.setState({ helpdesks: resp.data.data });
      });
    this.setState({ allowMessage: true });
  }

  select(id, initialLoading = true, show = true) {
    this.setState({
      loadingSelected: initialLoading,
      show,
      selected: id,
      // creating: false,
      inputText: [{ type: "paragraph", children: [{ text: "" }] }]
    });

    axios
      .post(`${URL.api}helpdesk/helpdesk/singleView/${id}`, null, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(resp => {
        this.setState(
          { messagesSelected: resp.data.data, loadingSelected: false },
          () => {
            setTimeout(
              () =>
                this.overflowDiv.current?.scrollIntoView({
                  behavior: "smooth",
                  block: "end"
                }),
              200
            );
          }
        );
      })
      .catch(error => {
        this.setState({ loadingSelected: false, loading: false });
        this.error("Não foi possível carregar a solicitação");
      });
  }

  changeStatus(open) {
    const previousStatus = this.state.messagesSelected.status;

    this.setState(state => ({
      messagesSelected: {
        ...state.messagesSelected,
        status: open ? "ABERTO" : "FECHADO"
      }
    }));

    axios
      .post(
        `${URL.api}helpdesk/helpdesk/update/${this.state.messagesSelected.id}`,
        { status: open ? "ABERTO" : "FECHADO" },
        { headers: { authorization: `Bearer ${this.props.user.token}` } }
      )
      .then(resp => {})
      .catch(error => {
        this.setState(state => ({
          messagesSelected: {
            ...state.messagesSelected,
            status: previousStatus
          }
        }));
        this.error("Não foi possível alterar o status da solicitação");
      });
  }

  sendMessage() {
    if (this.state?.inputText[0]?.children[0]?.text?.length !== 0) {
      this.setState({ allowMessage: false });
      this.handleClearCursor();
      const obj = {
        description: JSON.stringify(this.state.inputText),
        type_id: this.state.messagesSelected.type_id,
        obj_id: this.state.messagesSelected.obj_id,
        user_id: this.props.user.user.id,
        category_id: this.state.messagesSelected.category_id,
        status: this.state.messagesSelected.status,
        helpdesk_id: this.state.messagesSelected.id
      };

      axios
        .post(`${URL.api}helpdesk/helpdesk/insert`, obj, {
          headers: { authorization: `Bearer ${this.props.user.token}` }
        })
        .then(resp => {
          this.select(this.state.messagesSelected.id, false);

          this.reloadHelpdesks();
        })
        .catch(error => {
          this.error("Não foi possível enviar a mensagem");
        });
    }
  }

  sendNewMessage() {
    const obj = {
      description: JSON.stringify(this.state.inputText),
      user_id: this.props.user.user.id,
      category_id: this.state.createCategory,
      status: "ABERTO"
    };

    axios
      .post(`${URL.api}helpdesk/helpdesk/insert`, obj, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(resp => {
        this.select(resp.data.data, true);
        this.reloadHelpdesks();
      })
      .catch(error => {
        this.error("Não foi possível criar a solicitação");
      });
  }

  openContent(helpdesk) {
    switch (helpdesk.type_id) {
      case 1:
        this.setState({
          objId: helpdesk.obj_id,
          pageId: helpdesk.additional_obj_id,
          interfaceModal: true
        });
        break;
      case 25:
        this.setState({
          listId: helpdesk.additional_obj_id,
          questionId: helpdesk.obj_id,
          questionModal: true
        });
        break;
      default:
        this.setState({
          objId: helpdesk.obj_id,
          pageId: null,
          interfaceModal: true
        });
        break;
    }
  }

  render() {
    const selected =
      this.state.selected &&
      this.state.helpdesks.find(item => item.id === this.state.selected);

    return (
      <>
        {this.state.interfaceModal && (
          <Interface
            show={this.state.interfaceModal}
            title="Visualizador de conteúdo"
            onClose={() => this.setState({ interfaceModal: false })}
            aula={this.state.objId}
            pagina={this.state.pageId}
            currentRoute={this.props.currentRoute}
          />
        )}
        <QuestionViewerModal
          show={this.state.questionModal}
          onClose={() => this.setState({ questionModal: false })}
          question={this.state.questionId}
          list={this.state.listId}
        />
        {this.state.categoryModal && (
          <HelpdeskCategoryModal
            show={this.state.categoryModal}
            onClose={() =>
              this.setState({ categoryModal: false }, () => {
                this.select(this.state.messagesSelected.id, false);
                this.reloadHelpdesks();
              })
            }
            helpdesk={this.state.messagesSelected.id}
            category={this.state.messagesSelected.category_id}
          />
        )}
        <div className="row m-0" style={{ flex: 1 }}>
          <Breadcrumb current={this.props.currentRoute} />
          <div
            className={`col-12 col-md-3 p-0 d-md-block${
              this.state.show ? " d-none" : ""
            }`}
          >
            <CCard
              style={{
                borderTopRightRadius: 0,
                borderBottomRightRadius: 0,
                height: "calc(98vh - 106px - 4rem)"
              }}
            >
              <CCardHeader className="d-flex align-items-center justify-content-between">
                Helpdesk
                <div className="card-header-actions">
                  <CButton
                    color="white"
                    className="card-header-action remove-caret"
                    onClick={() => this.props.showHelpdesk()}
                  >
                    <i className="fa fa-plus-circle"></i>
                  </CButton>
                </div>
              </CCardHeader>
              <CCardBody className="p-0 overflow-auto">
                {this.state.loading ? (
                  <div className="p-4">
                    <Loading />
                  </div>
                ) : (
                  <CListGroup>
                    {this.state.helpdesks.map(item => (
                      <React.Fragment key={item.id}>
                        <CListGroupItem
                          action
                          active={selected && item.id === selected.id}
                          className="helpdesk-list-item d-none d-md-block"
                          onClick={() => this.select(item.id)}
                          style={{ borderRadius: 0 }}
                        >
                          <h5 className="w-100 text-ellipsis mb-1">
                            Ticket #{item.id}
                            <span className="small" style={{ opacity: 0.6 }}>
                              &nbsp;{item.category_name}
                            </span>
                          </h5>
                          <p
                            className="mb-1 text-ellipsis"
                            style={{ opacity: 0.8 }}
                          >
                            <Text simple ellipsis>
                              {item.last_comment || item.description}
                            </Text>
                          </p>
                          <div className="small" style={{ opacity: 0.6 }}>
                            {this.friendlyDate(
                              item.last_comment_created_at || item.created_at
                            )}
                          </div>
                        </CListGroupItem>
                        <CListGroupItem
                          action
                          className="helpdesk-list-item d-block d-md-none"
                          onClick={() => this.select(item.id)}
                          style={{ borderRadius: 0 }}
                        >
                          <h5 className="w-100 text-ellipsis mb-1">
                            Ticket #{item.id}
                            <span className="small" style={{ opacity: 0.6 }}>
                              &nbsp;{item.category_name}
                            </span>
                          </h5>
                          <p
                            className="mb-1 text-ellipsis"
                            style={{ opacity: 0.8 }}
                          >
                            <Text simple ellipsis>
                              {item.last_comment || item.description}
                            </Text>
                          </p>
                          <div className="small" style={{ opacity: 0.6 }}>
                            {this.friendlyDate(
                              item.last_comment_created_at || item.created_at
                            )}
                          </div>
                        </CListGroupItem>
                      </React.Fragment>
                    ))}
                  </CListGroup>
                )}
              </CCardBody>
            </CCard>
          </div>
          <div
            className={`col-12 col-md-9 p-0 d-md-block${
              this.state.show ? "" : " d-none"
            }`}
          >
            <CCard
              style={{
                borderLeft: 0,
                borderTopLeftRadius: 0,
                borderBottomLeftRadius: 0,
                height: "calc(98vh - 106px - 4rem)"
              }}
            >
              {!this.state.loadingSelected ? (
                <>
                  <CCardHeader className="d-flex align-items-center w-100">
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        flex: 1
                      }}
                    >
                      <h4 className="card-title mb-1">
                        <i
                          className="fa fa-angle-left mr-3 font-weight-bold cursor d-inline d-md-none"
                          onClick={() => this.setState({ show: false })}
                        ></i>
                        Ticket #{this.state.messagesSelected.id}
                        <span
                          className="small helpdesk-category-edit ml-1"
                          style={{ opacity: 0.6 }}
                          onClick={() => this.setState({ categoryModal: true })}
                        >
                          {this.state.messagesSelected.category_name}
                        </span>
                      </h4>
                      <div className="small text-muted">
                        Veja as mensagens dessa solicitação
                      </div>
                    </div>
                    <span className="text-muted mr-2">Aberto</span>
                    <CSwitch
                      color="primary"
                      shape="pill"
                      size="sm"
                      checked={this.state.messagesSelected.status === "ABERTO"}
                      onChange={e => this.changeStatus(e.target.checked)}
                    />
                  </CCardHeader>
                  <CCardBody className="p-0 d-flex flex-column overflow-auto">
                    <div
                      className="d-flex p-3 justify-content-end flex-column"
                      style={{ flex: 1 }}
                      ref={this.overflowDiv}
                    >
                      {(this.state.messagesSelected.screenshot ||
                        this.state.messagesSelected.link) && (
                        <div
                          className={`pt-3 d-flex justify-content-${
                            this.state.messagesSelected.user_id ===
                            this.props.user.user.id
                              ? "end"
                              : "start"
                          }`}
                        >
                          {this.state.messagesSelected.user_id !==
                            this.props.user.user.id && (
                            <div
                              className="c-avatar mr-3"
                              style={{ height: "30px", width: "30px" }}
                            >
                              <img
                                src={
                                  URL.img +
                                  (this.state.messagesSelected.user_photo ||
                                    "uploads/users/profileEmpty.jpg")
                                }
                                className="c-avatar-img"
                                alt="Usuário"
                              />
                            </div>
                          )}
                          <div
                            className={`p-2 ${
                              this.state.messagesSelected.user_id ===
                              this.props.user.user.id
                                ? "bg-primary text-white"
                                : "bg-light text-black"
                            }`}
                            style={{ borderRadius: "0.25rem", maxWidth: "70%" }}
                          >
                            <div
                              style={{
                                fontSize: "small",
                                fontStyle: "italic",
                                opacity: 0.6
                              }}
                              className="mb-2"
                            >
                              <i className="fa fa-cog mr-2"></i>Capturado pelo
                              sistema
                            </div>
                            {this.state.messagesSelected.screenshot && (
                              <img
                                alt=""
                                src={
                                  URL.img +
                                  this.state.messagesSelected.screenshot
                                }
                                className="mb-1"
                                style={{
                                  display: "block",
                                  maxWidth: "100%",
                                  maxHeight: "20em",
                                  borderRadius: "0.25rem"
                                }}
                              />
                            )}
                            {this.state.messagesSelected.link && (
                              <div>
                                <span className="font-weight-bold">URL: </span>
                                <CLink
                                  href={this.state.messagesSelected.link}
                                  style={{ color: "inherit" }}
                                >
                                  {this.state.messagesSelected.link}
                                </CLink>
                              </div>
                            )}
                            {this.state.messagesSelected.type_id !== 16 && (
                              <div>
                                <CButton
                                  className={`${
                                    this.state.messagesSelected.user_id ===
                                    this.props.user.user.id
                                      ? "bg-white text-primary"
                                      : "bg-secondary text-dark"
                                  } mt-2`}
                                  onClick={() =>
                                    this.openContent(
                                      this.state.messagesSelected
                                    )
                                  }
                                >
                                  Abrir conteúdo
                                </CButton>
                              </div>
                            )}
                            <div
                              className="d-flex justify-content-end small"
                              style={{ opacity: "75%" }}
                            >
                              {this.friendlyDate(
                                this.state.messagesSelected.created_at
                              )}
                            </div>
                          </div>
                          {this.state.messagesSelected.user_id ===
                            this.props.user.user.id && (
                            <div
                              className="c-avatar ml-3"
                              style={{ height: "30px", width: "30px" }}
                            >
                              <img
                                src={
                                  URL.img +
                                  (this.state.messagesSelected.user_photo ||
                                    "uploads/users/profileEmpty.jpg")
                                }
                                className="c-avatar-img"
                                alt="Usuário"
                              />
                            </div>
                          )}
                        </div>
                      )}
                      <div
                        className={`pt-3 d-flex justify-content-${
                          this.state.messagesSelected.user_id ===
                          this.props.user.user.id
                            ? "end"
                            : "start"
                        }`}
                      >
                        {this.state.messagesSelected.user_id !==
                          this.props.user.user.id && (
                          <div
                            className="c-avatar mr-3"
                            style={{ height: "30px", width: "30px" }}
                          >
                            <img
                              src={
                                URL.img +
                                (this.state.messagesSelected.user_photo ||
                                  "uploads/users/profileEmpty.jpg")
                              }
                              className="c-avatar-img"
                              alt="Usuário"
                            />
                          </div>
                        )}
                        <div
                          className={`p-2 ${
                            this.state.messagesSelected.user_id ===
                            this.props.user.user.id
                              ? "bg-primary text-white"
                              : "bg-light text-black"
                          }`}
                          style={{ borderRadius: "0.25rem", maxWidth: "70%" }}
                        >
                          {this.state.messagesSelected.user_id !==
                            this.props.user.user.id && (
                            <div className="d-flex small font-weight-bold">
                              {this.state.messagesSelected.user_name}
                            </div>
                          )}
                          <Text>{this.state.messagesSelected.description}</Text>
                          <div
                            className="d-flex justify-content-end small"
                            style={{ opacity: "75%" }}
                          >
                            {this.friendlyDate(
                              this.state.messagesSelected.created_at
                            )}
                          </div>
                        </div>
                        {this.state.messagesSelected.user_id ===
                          this.props.user.user.id && (
                          <div
                            className="c-avatar ml-3"
                            style={{ height: "30px", width: "30px" }}
                          >
                            <img
                              src={
                                URL.img +
                                (this.state.messagesSelected.user_photo ||
                                  "uploads/users/profileEmpty.jpg")
                              }
                              className="c-avatar-img"
                              alt="Usuário"
                            />
                          </div>
                        )}
                      </div>
                      {this.state.messagesSelected.comments
                        .slice(0)
                        .reverse()
                        .map(item => (
                          <div
                            key={item.id}
                            className={`pt-3 d-flex justify-content-${
                              item.user_id === this.props.user.user.id
                                ? "end"
                                : "start"
                            }`}
                          >
                            {item.user_id !== this.props.user.user.id && (
                              <div
                                className="c-avatar mr-3"
                                style={{ height: "30px", width: "30px" }}
                              >
                                <img
                                  src={
                                    URL.img +
                                    (item.user_photo ||
                                      "uploads/users/profileEmpty.jpg")
                                  }
                                  className="c-avatar-img"
                                  alt="Usuário"
                                />
                              </div>
                            )}
                            <div
                              className={`p-2 ${
                                item.user_id === this.props.user.user.id
                                  ? "bg-primary text-white"
                                  : "bg-light text-black"
                              }`}
                              style={{
                                borderRadius: "0.25rem",
                                maxWidth: "70%"
                              }}
                            >
                              {item.user_id !== this.props.user.user.id && (
                                <div className="d-flex small font-weight-bold">
                                  {item.user_name}
                                </div>
                              )}
                              <Text>{item.description}</Text>
                              <div
                                className="d-flex justify-content-end small"
                                style={{ opacity: "75%" }}
                              >
                                {this.friendlyDate(item.created_at)}
                              </div>
                            </div>
                            {item.user_id === this.props.user.user.id && (
                              <div
                                className="c-avatar ml-3"
                                style={{ height: "30px", width: "30px" }}
                              >
                                <img
                                  src={
                                    URL.img +
                                    (item.user_photo ||
                                      "uploads/users/profileEmpty.jpg")
                                  }
                                  className="c-avatar-img"
                                  alt="Usuário"
                                />
                              </div>
                            )}
                          </div>
                        ))}
                    </div>
                  </CCardBody>
                  {this.state.messagesSelected.status === "ABERTO" ? (
                    <CCardFooter className="flex-column align-items-end">
                      <CInputGroup className="h-100 mb-2">
                        <Input
                          value={this.state.inputText}
                          onChange={value =>
                            this.setState({ inputText: value })
                          }
                          clearCursor={this.state.clearCursor}
                          placeholder="Digite uma mensagem"
                        />
                      </CInputGroup>
                      <CButton
                        color="primary"
                        onClick={() => this.sendMessage()}
                        disabled={!this.state.allowMessage}
                      >
                        <i className="fa fa-send"></i>&nbsp; Enviar
                      </CButton>
                    </CCardFooter>
                  ) : (
                    <CCardFooter className="flex-column align-items-center py-5">
                      <span className="text-muted">
                        Para enviar uma mensagem, reabra o ticket
                      </span>
                    </CCardFooter>
                  )}
                </>
              ) : (
                <CCardBody className="justify-content-center align-items-center d-flex flex-column text-muted">
                  <div className="p-4"></div>
                </CCardBody>
              )}
              <ProtectedRoute routeId={this.props.currentRoute} />
            </CCard>
          </div>
        </div>
      </>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      setObj,
      logout,
      showHelpdesk
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(Helpdesk);
